import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<button type=\"button\" class=\"copy-btn\" ...attributes {{on \"click\" (perform this.copy)}}>\n  {{yield}}\n</button>\n", {
  moduleName: "ilios-common/components/copy-button.hbs"
});